export default "__VITE_ASSET__uNLeptMb__"